<script>
  import { routes } from '../../stores/router'
  import { buildUrl, navigate, shouldNavigate } from './navigation'
  export let to
  export let active = false
  export let params = {}

  const route = $routes.find(r => r.name === to)
  const url = buildUrl(route, params)

  function onClick(event) {
    if (shouldNavigate(event)) {
      event.preventDefault()
      navigate(route, params)
    }
  }
</script>

<style>
  a {
    text-decoration: none;
  }
</style>

<a href={url} on:click={onClick} aria-current={active ? 'page' : ''}>
  <slot />
</a>
